import React, { SetStateAction } from "react";
import VerifiedIcon from "../../../../../../icons/PostYourProperty/VerifiedIcon";
import { Button } from "../../../../../../shadcn/components/ui/button";

interface Props {
  activeStep: number;
  setActiveStep: React.Dispatch<SetStateAction<number>>;
  totalSteps: number;
}

export const JBStepperComponent = ({
  activeStep,
  setActiveStep,
  totalSteps,
}: Props) => {
  const getBidderLabel = (index: number) => {
    return index === 0 ? "Primary Bidder" : `Bidder ${index + 1}`;
  };

  const getBidderDetailsLabel = (index: number) => {
    return index === 0
      ? "Primary Bidder Details"
      : `Bidder ${index + 1} Details`;
  };

  const isStepCompleted = (index: number) => activeStep > index;
  const isStepActive = (index: number) => activeStep === index;
  const isLastStep = (index: number) => index + 1 === totalSteps;
  return (
    <>
      {/* Mobile Stepper */}
      <div className="flex mb-5 lg:hidden w-full">
        <ul className="flex justify-between w-full">
          {Array.from({ length: totalSteps }, (_, index) => (
            <li className={isLastStep(index) ? "" : "flex-1"} key={index}>
              <div className="flex items-start">
                {isStepCompleted(index) ? (
                  <div
                    className="hover:cursor-pointer h-fit"
                    onClick={() => setActiveStep(index)}
                  >
                    <VerifiedIcon />
                  </div>
                ) : (
                  <Button
                    variant="custom"
                    size="custom"
                    className={`rounded-full bg-transparent border min-h-[26px] min-w-[26px] ${
                      isStepActive(index)
                        ? "border-brand-bgBlack border-[0.5px]"
                        : "border-[#5D5FEF] border-[0.5px]"
                    }`}
                  >
                    {isStepActive(index) && (
                      <div className="rounded-full bg-black h-3 w-3" />
                    )}
                  </Button>
                )}
                <div
                  className={`border-t-[1px] border-[#5D5FEF] mt-3 w-full ${
                    isLastStep(index) ? "hidden" : ""
                  }`}
                />
              </div>
              <div
                onClick={() => {
                  if (isStepCompleted(index)) setActiveStep(index);
                }}
                className="mt-3 -translate-y-[6px] hover:cursor-pointer"
              >
                <p
                  className={`font-openSans font-normal text-mobile-body-sm lg:text-[20px] leading-4 lg:leading-7 ${
                    isStepCompleted(index) || isStepActive(index)
                      ? "text-brand-bgBlack"
                      : "text-brand-textLightGrey"
                  }`}
                >
                  Add Details
                </p>
                <p
                  className={`font-openSans font-normal text-mobile-body-xsm lg:text-web-body-md leading-[13px] lg:leading-5 ${
                    isStepCompleted(index) || isStepActive(index)
                      ? "text-brand-bgBlack"
                      : "text-brand-textLightGrey"
                  }`}
                >
                  {getBidderLabel(index)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Web Stepper */}
      <div className="mr-10 bg-[position:left_-7px] bg-no-repeat hidden lg:flex lg:max-w-[260px] mid:max-w-[291px] w-full bg-brand-lightBlue h-fit pl-[22px] pr-[60px] pt-[50px] pb-[60px] clip-path-mobileClipPolygonTopRight">
        <ul>
          {Array.from({ length: totalSteps }, (_, index) => (
            <li className="flex items-start" key={index}>
              <div className="flex flex-col items-center">
                {isStepCompleted(index) ? (
                  <div
                    className="hover:cursor-pointer h-fit"
                    onClick={() => setActiveStep(index)}
                  >
                    <VerifiedIcon />
                  </div>
                ) : (
                  <Button
                    variant="custom"
                    size="custom"
                    className={`rounded-full bg-transparent border h-[26px] w-[26px] ${
                      isStepActive(index)
                        ? "border-brand-bgBlack border-[0.5px]"
                        : "border-[#5D5FEF] border-[0.5px]"
                    }`}
                  >
                    {isStepActive(index) && (
                      <div className="rounded-full bg-black h-3 w-3" />
                    )}
                  </Button>
                )}

                <div
                  className={`border-l-[1px] border-[#5D5FEF] h-[90px] my-1 ${
                    isLastStep(index) ? "hidden" : ""
                  }`}
                />
              </div>
              <div
                onClick={() => {
                  if (isStepCompleted(index)) setActiveStep(index);
                }}
                className="ml-3 -translate-y-[6px] hover:cursor-pointer"
              >
                <p
                  className={`font-openSans font-normal text-[20px] leading-7 ${
                    isStepCompleted(index) || isStepActive(index)
                      ? "text-brand-bgBlack"
                      : "text-brand-textLightGrey"
                  }`}
                >
                  {getBidderDetailsLabel(index)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
